import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isShowPopup: false,
    stageChildren: {},
    opensStages: {},
    opensCharters: {},
    laborCount: 0,
    positionsWithPlanned: [],
    chartersPlannedDate: {},
    stagesWithPlanned: {},
    laborGuids: [],
    settings: {
        daysMHD: '3',
        isShowMHD: false,
        duration: 'day',
    },
    chainPositionMove: {
        positionX: 0,
        guids: [],
    },
    isLoading: true,
    activeTab: 'day',
    days: [],
    weeks: [],
    months: [],
    nestingTabs: 'stages',
    isNeedUpdateStart: true,
    firstStageStart: '',
};

const gantSlice = createSlice({
    name: 'gant',
    initialState,
    reducers: {
        changeFirstStageStart: (state, { payload }) => {
            state.firstStageStart = payload;
        },
        changeNeedUpdateStart: (state, { payload }) => {
            state.isNeedUpdateStart = payload;
        },
        changeNestingTabs: (state, { payload }) => {
            state.nestingTabs = payload;
        },
        changeShowPopup: (state, { payload }) => {
            state.isShowPopup = payload;
        },
        setStageChildren: (state, { payload }) => {
            state.stageChildren = payload;
        },
        setLaborGuids: (state, action) => {
            state.laborGuids = [...action.payload];
        },
        setPositionsWithPlanned: (state, action) => {
            state.positionsWithPlanned = [...action.payload];
        },
        setChartersPlannedDate: (state, action) => {
            state.chartersPlannedDate = action.payload;
        },
        setStagesPlannedDate: (state, action) => {
            state.stagesWithPlanned = action.payload;
        },
        changeOpenStage: (state, { payload }) => {
            state.opensStages = payload;
        },
        changeOpenCharters: (state, { payload }) => {
            state.opensCharters = payload;
        },
        setLaborCount: (state, action) => {
            state.laborCount = action.payload;
        },
        changeSettings: (state, action) => {
            state.settings = action.payload;
        },
        changeChainPositionMove: (state, action) => {
            state.chainPositionMove.positionX = action.payload;
        },
        changeChainPositionMoveGuids: (state, action) => {
            state.chainPositionMove.guids = action.payload;
        },
        changeIsLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        changeTab: (state, action) => {
            state.activeTab = action.payload;
        },
        setDays: (state, action) => {
            state.days = action.payload;
        },
        setWeeks: (state, action) => {
            state.weeks = action.payload;
        },
        setMonths: (state, action) => {
            state.months = action.payload;
        },
    },
});

export const { actions: gantActions } = gantSlice;
export const { reducer: gantReducer } = gantSlice;
